import { buildAction } from 'store/actions/actionCreator'

import { FETCH_OWNERS } from './constants'

export const fetchOwners = buildAction(FETCH_OWNERS, 'payload')
